module.exports = __webpack_public_path__ + "img/2.ef11d0ff.jpg";